import { LockStatus, SmopUserTypeCode } from "@saleor/types/globalTypes";

// TODO: Make all methods & properties "Type Safe" in this file. E.g. use interfaces

export const getStaffUserType = staffMember => {
  const hasPermissionGroup =
    staffMember?.permissionGroups?.map(code => code.smopUsertypeCode) || " ";

  const userTypeCode = staffMember?.accessGroup?.smopUsertypeCode || "";
  const isSmopAdmin = Object.values(SmopUserTypeCode).includes(userTypeCode);

  const isOmiAdmin = Object.values(hasPermissionGroup).includes(
    SmopUserTypeCode.OMI_ADMIN
  );

  let result = {
    accesses: [],
    code: "",
    description: ""
  };
  if (isSmopAdmin) {
    let description = "";
    switch (userTypeCode) {
      case SmopUserTypeCode.ACCOUNT_MANAGER:
        description = "Kams";
        break;
      case SmopUserTypeCode.ACQUISITION:
        description = "Acquisition";
        break;
      case SmopUserTypeCode.CUSTOMER:
        description = "Customer";
        break;
      case SmopUserTypeCode.MALL_ADMIN:
        description = "Mall Admin";
        break;
      case SmopUserTypeCode.MARKETING:
        description = "Marketing";
        break;
      case SmopUserTypeCode.SELLER_MASTER:
        description = "Seller Master";
        break;
      case SmopUserTypeCode.STORE_ADMIN:
        description = "Store Admin";
        break;
      case SmopUserTypeCode.OMI_ADMIN:
        description = "OMI Admin";
        break;
      case SmopUserTypeCode.OMI_FINANCE:
        description = "OMI Finance";
        break;
      case SmopUserTypeCode.OMI_OPS:
        description = "OMI Ops";
        break;
      case SmopUserTypeCode.RIDER:
        description = "Rider";
        break;
      case SmopUserTypeCode.RUNNER:
        description = "Runner";
        break;
    }
    result = {
      accesses: staffMember.accessGroup.accesses,
      code: userTypeCode,
      description
    };
  } else if (isOmiAdmin) {
    result = {
      accesses: [],
      code: SmopUserTypeCode.OMI_ADMIN,
      description: "OMI Admin"
    };
  }

  return result;
};

export const getStaffStatus = staffMember => {
  const status = staffMember?.status || "";
  const isValidStatus = Object.values(LockStatus).includes(status);

  let result = {
    description: "",
    status: ""
  };

  if (isValidStatus) {
    let description = "";

    if (status === LockStatus.ACTIVE) {
      description = "Active";
    }
    if (status === LockStatus.BLOCKED) {
      description = "Blocked";
    }
    if (status === LockStatus.INACTIVE) {
      description = "Inactive";
    }
    if (status === LockStatus.UNVERIFIED) {
      description = "Unverified";
    }

    result = {
      description,
      status
    };
  }

  return result;
};
